import { Component, Input } from '@angular/core';
import { PrimitiveType } from '../../../class/workflow.type';
import { StringVariableService } from '../../../service/string-variable/string-variable.service';
import { WorkflowDictionaryService } from '../../../service/workflow-dictionary/workflow-dictionary.service';
import { WorkflowPageNavigationService } from '../../../service/workflow-page-navigation/workflow-page-navigation.service';

@Component({
  selector: 'cu-validation-messages',
  templateUrl: './validation-messages.component.html',
  styleUrls: ['./validation-messages.component.scss']
})
export class ValidationMessagesComponent {
  /** list of failed validation keys e.g. field.config.failedValidations or card.config.failedValidations   */
  @Input() public displayFormat: 'line' | 'alert' = 'line';
  @Input() public pageIterationId: number;
  @Input() public fieldId: string;
  @Input() public fieldLabel: string;
  @Input() public iterationId: number;

  /** list of failed validation keys e.g. field.config.failedValidations or card.config.failedValidations   */
  @Input() public failedValidations: string[];

  /** custom validation messages e.g. field.config.validationMsg or card.config.validationMsg */
  @Input() public validationMessages: { [key: string]: string };

  constructor(
    public readonly dictionaryService: WorkflowDictionaryService,
    public readonly dynamicPageService: WorkflowPageNavigationService,
    public readonly stringVariableService: StringVariableService
  ) {}

  // Get generic validation string from workflow dictionary
  public getValidationMessage(validationName: string): PrimitiveType {
    return (
      (this.validationMessages &&
        this.stringVariableService.parse(this.validationMessages[validationName], this.iterationId, this.pageIterationId, '', true)) ||
      this.dictionaryService.read('validation', validationName)
    );
  }

  // Create a detailed validation message using the field label if available
  public getDetailedValidationMessage(validationName: string): PrimitiveType {
    const message = this.getValidationMessage(validationName) as string;
    if (this.fieldLabel?.length) {
      return message.replace(/this/gi, this.fieldLabel);
    }
    return message;
  }
}
